import { Visibility } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";
import { useController } from "react-hook-form";
import ClosedEyeIcon from "./Icons/ClosedEyeIcon";

const TextInput = ({
  type,
  sx,
  onWheel,
  name,
  control,
  rules,
  onChange,
  noDecimal,
  ...others
}) => {
  const { field, fieldState } = useController({ name, control, rules });
  const isNumberField = type === "number";
  const isPasswordField = type === "password";
  const numbersStyle = isNumberField
    ? {
        "& input[type=number]": {
          MozAppearance: "textfield",
          "&::-webkit-outer-spin-button": {
            WebkitAppearance: "none",
            margin: 0,
          },
          "&::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
            margin: 0,
          },
        },
      }
    : {};
  const preventInvalidKeys = (event) => {
    if (isNumberField) {
      if (event.key === "e" || event.key === "-" || event.key === "+") {
        event.preventDefault();
      }
      if (noDecimal && event.key === ".") {
        event.preventDefault();
      }
    }
  };
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <TextField
      sx={{ ...sx, ...numbersStyle }}
      onWheel={isNumberField ? (e) => e.target.blur() : onWheel}
      type={isPasswordField ? (showPassword ? "text" : "password") : type}
      {...field}
      value={field.value || ""}
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
      onKeyDown={preventInvalidKeys}
      onChange={onChange || field.onChange}
      InputProps={{
        endAdornment: isPasswordField && (
          <InputAdornment position="end">
            <IconButton onClick={handleTogglePasswordVisibility} edge="end">
              {showPassword ? <Visibility /> : <ClosedEyeIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...others}
    />
  );
};

export default TextInput;
